import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-[#D4C4B0] shadow-lg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#2C2C2C] text-sm sm:text-base">
            Ce site utilise des cookies pour améliorer votre expérience. En continuant à naviguer, vous acceptez notre{' '}
            <a href="/politique-de-confidentialite" className="text-[#8B4513] hover:underline">
              politique de confidentialité
            </a>
            .
          </p>
          <button
            onClick={acceptCookies}
            className="px-6 py-2 bg-[#8B4513] text-white rounded-md hover:bg-[#A0522D] transition-all duration-300 whitespace-nowrap"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
